<template>
  <Breadcrumbs />
  <DynamicContent
    id="blog-content-introduction"
    class="container dynamic-content"
    :html="content?.introductionBlock"
  ></DynamicContent>

  <BlogPostGrid class="mb-4" />

  <DynamicContent
    id="blog-content-similar"
    class="container dynamic-content"
    :html="content?.similarBlock"
  ></DynamicContent>
  <DynamicContent
    id="blog-content-timed"
    class="container dynamic-content"
    :html="content?.timedBlock"
  ></DynamicContent>
  <DynamicContent
    id="blog-content-offers"
    class="container dynamic-content"
    :html="content?.offersBlock"
  ></DynamicContent>
</template>

<script setup lang="ts">
import { useWebsitePageQuery } from "~/graphql/generated";

const { t } = useI18n();

useSeoMeta({
  title: t("blog.title"),
  description: t("blog.meta-description"),
  ogDescription: t("blog.meta-description"),
});

// Set the (optional) page content blocks
const path = useRoute().path;
const { websitePagePath } = useWebsitePagePath(path);
const page = await useWebsitePageQuery({ variables: websitePagePath });
const content = useDynamicContent(page.data);
</script>

<style lang="scss" scoped></style>
